import { actions } from './patient_medicine/actions'
import { getters } from './patient_medicine/getters'
import { state } from './patient_medicine/state'
import { mutations } from './patient_medicine/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}